export const getStructuredFAQ = (props, dataPageType) => {
  const { emtData } = props;
  const emtContentFileData = emtData?.emtContent?.content?.[dataPageType];
  let faqs = [];
  let mainEntity = [];

  if (Array.isArray(emtContentFileData)) {
    faqs = emtContentFileData?.[0]?.faq;
  } else {
    faqs = emtContentFileData?.faq;
  }

  if (faqs?.length > 0) {
    mainEntity = faqs.map((faq) => {
      return ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      });
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity
  };
};